import { gql } from "@apollo/client";

export const getAllHost = gql`
  query GetAllHost (
    $pageNumber: Int!
    $pageSize: Int!
    $status: String
    $search: String
    $level: [String!]
    $city: String
    $state: String
    ) {
    getAllHost (
      pageNumber: $pageNumber
      pageSize: $pageSize
      status: $status
      search: $search
      level: $level
      city: $city
      state: $state
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {  
        phone_number
        name
        email
        location_address
        authId
        hostStatus
        city
        state
        zipCode
      }
    }
}`;

export const approveUpdateRole = gql`
  mutation ApproveUpdateRole ($authId: String!) {
    approveUpdateRole(authId: $authId) {
        message
    }
}`;

export const rejecteUpdateRole = gql`
  mutation RejecteUpdateRole ($authId: String!) {
    rejecteUpdateRole(authId: $authId) {
        message
    }
}`;
